{
  "version": 1,
  "asset_id": "d4709af5-76cb-4388-9a87-1ff660a37cf1",
  "project_id": "734c54a9-ffec-4c25-9063-92ce0fc791b9",
  "url": "/__l5e/assets-v1/d4709af5-76cb-4388-9a87-1ff660a37cf1/retatrutide-before-after-4-weeks.jpg",
  "r2_key": "a/v1/734c54a9-ffec-4c25-9063-92ce0fc791b9/d4709af5-76cb-4388-9a87-1ff660a37cf1/retatrutide-before-after-4-weeks.jpg",
  "original_filename": "retatrutide-before-after-4-weeks.jpg",
  "size": 110690,
  "content_type": "image/jpeg",
  "created_at": "2026-07-10T12:03:19Z"
}
